// Auto-assign IDs to rich-text headings so jump-to anchors work without
// the CMS author hand-editing the HTML source view.
//
// On page load, walks every heading (h2-h5) inside `.rte` and:
//   1. Skips it if it already has an id.
//   2. Generates a URL-safe slug from the heading's text content.
//   3. Sets that slug as the heading's id.
//
// So a "Jump To Block" can reference `#students` and as long as the
// rich text has <h2>Students</h2>, the anchor resolves automatically.
//
// Idempotent — re-running on the same DOM is a no-op.

const HEADING_SELECTOR = '.rte h2, .rte h3, .rte h4, .rte h5'

// Slugify: lowercase, strip accents, replace non-alphanumeric runs with
// hyphens, collapse repeats, trim hyphens off the ends.
function slugify(text) {
    return (text || '')
        .toString()
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')   // strip combining marks (accents)
        .toLowerCase()
        .replace(/['"’]/g, '')             // drop apostrophes outright
        .replace(/[^a-z0-9]+/g, '-')       // anything else → hyphen
        .replace(/^-+|-+$/g, '')           // trim hyphens
        .replace(/-{2,}/g, '-')            // collapse runs of hyphens
}

function uniquify(slug, used) {
    if (!used.has(slug)) {
        used.add(slug)
        return slug
    }
    let n = 2
    while (used.has(`${slug}-${n}`)) n++
    const result = `${slug}-${n}`
    used.add(result)
    return result
}

const autoHeadingIds = {
    init() {
        const headings = document.querySelectorAll(HEADING_SELECTOR)
        if (!headings.length) return

        // Track every id already on the page so we don't collide.
        const used = new Set()
        document.querySelectorAll('[id]').forEach((el) => used.add(el.id))

        headings.forEach((h) => {
            if (h.id) return
            const slug = slugify(h.textContent)
            if (!slug) return
            h.id = uniquify(slug, used)
        })
    },
}

export default autoHeadingIds
